import React from "react";
import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Box,
  useTheme,
} from "@mui/material";
import { panelStyles } from "../PanelStyles";
import { SourceTypeToggleProps } from "./types";
import { SourceTypeValues } from "../../types/frontend";

/* * SourceTypeToggle component allows users to switch between different source types
 * (e.g., scientific literature and Materiom formulations).
 * It uses MUI's ToggleButtonGroup for the toggle functionality.
 * @param {Object} props - Component properties
 * @param {string} props.sourceType - Current source type ('scientific' or 'materiom')
 * @param {Function} props.onChange - Callback function to handle source type changes
 */
const SourceTypeToggle: React.FC<SourceTypeToggleProps> = ({
  sourceType,
  onChange,
}) => {
  const theme = useTheme();
  // TODO: Once the Materiom Formulations feature is stable enough, we can remove
  // this flag and the case where the toggle is disabled. Alternatively, in the
  // future, we can think of using feature flags to enable/disable this and other
  // features.
  const isMateriomFormulationsEnabled = true;

  return (
    <Box>
      <ToggleButtonGroup
        value={sourceType}
        exclusive
        onChange={onChange}
        fullWidth
        size="small"
        sx={panelStyles.toggleButtonGroup}
      >
        {/* Scientific sources toggle */}
        <Tooltip
          title="Search the open-access scientific literature"
          placement="bottom"
        >
          <ToggleButton
            value={SourceTypeValues.ScientificSource}
            sx={panelStyles.toggleButton}
            disableRipple
            data-attr="scientific-sources-toggle"
          >
            Scientific Sources
          </ToggleButton>
        </Tooltip>

        {/* Materiom toggle - disabled with tooltip */}
        <Tooltip
          title={
            isMateriomFormulationsEnabled ? (
              <div style={{ textAlign: "center" }}>
                Search Materiom's database of bio-based material formulations
              </div>
            ) : (
              <div style={{ textAlign: "center" }}>
                Coming soon: Search Materiom's database of bio-based material
                formulations
              </div>
            )
          }
        >
          <span style={{ width: "50%", marginLeft: theme.spacing(-1.25) }}>
            <ToggleButton
              value={SourceTypeValues.MateriomFormulation}
              sx={panelStyles.toggleButton}
              disabled={!isMateriomFormulationsEnabled}
              disableRipple
              data-attr="materiom-formulations-sources-toggle"
            >
              Materiom Formulations
            </ToggleButton>
          </span>
        </Tooltip>
      </ToggleButtonGroup>
    </Box>
  );
};

export default SourceTypeToggle;
